import script from "./NoProfessionalAssigned.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoProfessionalAssigned.vue?vue&type=script&setup=true&lang=ts"

import "./NoProfessionalAssigned.vue?vue&type=style&index=0&id=6eeeecaa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eeeecaa"]])

export default __exports__